import axios from 'axios';

const BACKEND_URL = "https://drive-sync-service-920659546977.asia-south1.run.app";
const API = `${BACKEND_URL}/api`;

// API service for demo requests
export const demoRequestAPI = {
  // Submit a new demo request
  create: async (requestData) => {
    try {
      const response = await axios.post(`${API}/demo-requests`, requestData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      // Handle CORS errors specifically
      const isCorsError = 
        !error.response && 
        (error.message?.includes('CORS') || 
         error.message?.includes('Network Error') ||
         error.message?.includes('Access-Control') ||
         error.code === 'ERR_NETWORK');
      
      if (isCorsError) {
        throw new Error('Demo request service is temporarily unavailable. Please contact us directly at pankaj@levellex.com');
      }
      
      // Handle network errors
      if (!error.response) {
        throw new Error('Network error. Please check your connection and try again.');
      }
      
      // Handle server errors
      if (error.response?.data?.detail) {
        throw new Error(error.response.data.detail);
      }
      
      throw new Error('Failed to submit demo request. Please try again later.');
    }
  },

  // Get all demo requests (admin functionality)
  getAll: async () => {
    try {
      const response = await axios.get(`${API}/demo-requests`);
      return response.data;
    } catch (error) {
      // Handle CORS errors specifically
      const isCorsError = 
        !error.response && 
        (error.message?.includes('CORS') || 
         error.message?.includes('Network Error') ||
         error.message?.includes('Access-Control') ||
         error.code === 'ERR_NETWORK');
      
      if (isCorsError) {
        throw new Error('Demo request service is temporarily unavailable.');
      }
      
      // Handle network errors
      if (!error.response) {
        throw new Error('Network error. Please check your connection and try again.');
      }
      
      if (error.response?.data?.detail) {
        throw new Error(error.response.data.detail);
      }
      throw new Error('Failed to fetch demo requests.');
    }
  },

  // Get specific demo request by ID
  getById: async (id) => {
    try {
      const response = await axios.get(`${API}/demo-requests/${id}`);
      return response.data;
    } catch (error) {
      // Handle CORS errors specifically
      const isCorsError = 
        !error.response && 
        (error.message?.includes('CORS') || 
         error.message?.includes('Network Error') ||
         error.message?.includes('Access-Control') ||
         error.code === 'ERR_NETWORK');
      
      if (isCorsError) {
        throw new Error('Demo request service is temporarily unavailable.');
      }
      
      // Handle network errors
      if (!error.response) {
        throw new Error('Network error. Please check your connection and try again.');
      }
      
      if (error.response?.data?.detail) {
        throw new Error(error.response.data.detail);
      }
      throw new Error('Failed to fetch demo request.');
    }
  }
};

export default demoRequestAPI;